import { omit } from 'ts-utils';
import { StoreStateInternal } from '../Store';
import { AssessmentUser, UserState } from './UserState';

export const UserSelector = {
  userState(state: StoreStateInternal): UserState {
    return state.user;
  },
  user(state: StoreStateInternal): AssessmentUser {
    return omit(state.user, ['loading', 'error']) as AssessmentUser;
  },
};
